import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { Route } from 'react-router-dom';
import { RoutesExtensionInterface } from '../../../extension/interface/routes.extension.interface';
import { BikeleasingV2Routes } from '../../../page/BenefitBikeleasingPage/BikeleasingV2Routes';
import PrivatePage from '../../auth/PrivatePage';

export class BikeleasingRoutesExtension extends RoutesExtensionInterface {
  get routes(): React.ReactNode {
    return <Route path={`/${BenefitDTOBenefitEnum.BikeleasingV2.toLowerCase()}/*`} element={<PrivatePage page={BikeleasingV2Routes} />} />;
  }
}
